module.exports = __webpack_public_path__ + "static/img/PATRICK-WECKERT.fbb8376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PATRICK-WECKERT.jpg
// module id = JBIH
// module chunks = 0